import { createSlice } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const initialState = {
  data: null,
};

const apiUrl = process.env.REACT_APP_API_URL;

export const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setUser: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.data = state.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser } = userSlice.actions;

export default userSlice.reducer;

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({
    baseUrl: apiUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = JSON.parse(localStorage.getItem("auth"))?.jwt;

      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      headers.set("Content-type", "application/json");
      headers.set("Accept", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getUser: builder.query({
      query: (id) => `/users/${id}`,
    }),
    getUsers: builder.query({
      query: ({ page, size }) =>
        `/users?pagination[page]=${page}&pagination[pageSize]=${size}&sort=id:desc&populate=*&filters[blocked][$eq]=false&filters[confirmed][$eq]=true`,
    }),
    getUsersBlocked: builder.query({
      query: ({ page, size }) =>
        `/users?pagination[page]=${page}&pagination[pageSize]=${size}&sort=id:desc&populate=*&filters[blocked][$eq]=true`,
    }),
    postUser: builder.mutation({
      query: (data) => ({
        url: `/users`,
        method: "POST",
        body: data,
      }),
    }),

    updateUser: builder.mutation({
      query: ({ id, data }) => ({
        url: `/users/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["User"],
    }),

    deleteUser: builder.mutation({
      query: (id) => ({
        url: `/users/${id}`,
        method: "PUT",
        body: { blocked: true, confirmed: false }, // Assuming you want to block the user instead of deleting
      }),
    }),
    activateUser: builder.mutation({
      query: (id) => ({
        url: `/users/${id}`,
        method: "PUT",
        body: { blocked: false, confirmed: true }, // Assuming you want to block the user instead of deleting
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetUserQuery,
  usePostUserMutation,
  useGetUsersQuery,
  useLazyGetUsersQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useLazyGetUsersBlockedQuery,
  useActivateUserMutation,
} = userApi;
